<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="1400px"
    append-to-body
    custom-class="joint-split-detail-dialog"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <template slot="title">
      <div class="dialog-title-with-bar">
        <span class="title-bar" aria-hidden="true" />
        <span class="title-text">分账明细</span>
      </div>
    </template>

    <div v-loading="loading" class="split-detail-body">
      <el-table
        :data="summaryTableRows"
        border
        size="small"
        class="split-block-table split-summary-table"
      >
        <el-table-column label="融资金额" min-width="100" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.investPrice) }}</template>
        </el-table-column>
        <el-table-column label="计划分账金额" min-width="110" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.planRentRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column label="租金已分账金额" min-width="120" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execRentRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column label="订单取消分账" min-width="120" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execOtherRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column label="已分账本金" min-width="100" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execPrincipleRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column label="已分账收益" min-width="100" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execProfitRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column label="已分账总金额" min-width="110" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execTotalRoyaltyPrice) }}</template>
        </el-table-column>
      </el-table>

      <el-table
        :data="rentRoyaltyBillList"
        border
        size="small"
        class="split-block-table split-period-table"
        max-height="560"
        empty-text="暂无租金分账明细"
      >
        <el-table-column prop="billNum" label="期数" width="64" align="left" />
        <el-table-column prop="billDate" label="账单日" min-width="108" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.billDate) }}</template>
        </el-table-column>
        <el-table-column prop="rentPrice" label="租金" min-width="96" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.rentPrice) }}</template>
        </el-table-column>
        <el-table-column prop="leftRentPrice" label="租金（押抵后）" min-width="100" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.leftRentPrice) }}</template>
        </el-table-column>
        <el-table-column prop="investPrinciplePrice" label="本金" min-width="88" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.investPrinciplePrice) }}</template>
        </el-table-column>
        <el-table-column prop="planProfitPrice" label="预估收益" min-width="96" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.planProfitPrice) }}</template>
        </el-table-column>
        <el-table-column prop="execProfitPrice" label="实际收益" min-width="96" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execProfitPrice) }}</template>
        </el-table-column>
        <el-table-column prop="planRoyaltyPrice" label="预估分账" min-width="96" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.planRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column prop="execRoyaltyPrice" label="实际分账" min-width="96" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.execRoyaltyPrice) }}</template>
        </el-table-column>
        <el-table-column prop="royaltyStatus" label="分账状态" min-width="100" align="left">
          <template slot-scope="{ row }">{{ getRoyaltyStatusName(row.royaltyStatus) }}</template>
        </el-table-column>
        <el-table-column prop="royaltyTime" label="分账时间" min-width="160" align="left">
          <template slot-scope="{ row }">{{ displayCell(row.royaltyTime) }}</template>
        </el-table-column>
      </el-table>

      <template v-if="showOtherRoyaltyBill">
        <div class="block-label">订单取消分账</div>
        <el-table
          :data="otherRoyaltyBillRows"
          border
          size="small"
          class="split-block-table split-buyout-table"
        >
          <el-table-column label="本金" min-width="100" align="left">
            <template slot-scope="{ row }">{{ displayCell(row.investPrinciplePrice) }}</template>
          </el-table-column>
          <el-table-column label="收益" min-width="100" align="left">
            <template slot-scope="{ row }">{{ displayCell(row.execProfitPrice) }}</template>
          </el-table-column>
          <el-table-column label="分账金额" min-width="110" align="left">
            <template slot-scope="{ row }">{{ displayCell(row.execRoyaltyPrice) }}</template>
          </el-table-column>
          <el-table-column label="分账状态" min-width="100" align="left">
            <template slot-scope="{ row }">{{ getRoyaltyStatusName(row.royaltyStatus) }}</template>
          </el-table-column>
          <el-table-column label="分账时间" min-width="170" align="left">
            <template slot-scope="{ row }">{{ displayCell(row.royaltyTime) }}</template>
          </el-table-column>
        </el-table>
      </template>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="innerVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getJointOrderRoyaltyDetailAPI } from "../api";

const royaltyStatusMap = {
  0: "无需分账",
  1: "待分账",
  2: "已分账",
  3: "已关闭"
};

const royaltyTypeMap = {
  1: "按期分账",
  2: "提前买断分账",
  3: "订单取消分账"
};

function displayCell(v) {
  if (v === null || v === undefined || v === "") {
    return "-";
  }
  return v;
}

export default {
  name: "JointOrderSplitDetailDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      detail: null,
    };
  },
  computed: {
    summaryTableRows() {
      return this.detail ? [this.detail] : [];
    },
    rentRoyaltyBillList() {
      return this.detail?.rentRoyaltyBillList || [];
    },
    otherRoyaltyBill() {
      return this.detail?.otherRoyaltyBill || null;
    },
    showOtherRoyaltyBill() {
      return !!this.otherRoyaltyBill;
    },
    otherRoyaltyBillRows() {
      return this.showOtherRoyaltyBill ? [this.otherRoyaltyBill] : [];
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.$nextTick(() => this.loadDetail());
        }
      },
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    displayCell,
    getRoyaltyStatusName(status) {
      if (status === null || status === undefined || status === "") {
        return "-";
      }
      return royaltyStatusMap[status] || status;
    },
    onClose() {
      this.detail = null;
      this.$emit("close");
    },
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.row?.id;
        if (id == null) {
          this.detail = null;
          return;
        }
        this.detail = await getJointOrderRoyaltyDetailAPI({ id });
      } catch {
        this.detail = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title-with-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  .title-bar {
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #409eff;
    border-radius: 1px;
    flex-shrink: 0;
  }
  .title-text {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

.split-detail-body {
  padding: 0 4px 8px;
}

.block-label {
  margin: 20px 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.dialog-footer {
  text-align: right;
}
</style>

<style lang="scss">
.joint-split-detail-dialog {
  .split-summary-table {
    margin-bottom: 16px;
  }
  .split-period-table {
    margin-bottom: 4px;
  }
}
</style>
